var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-tab",class:[_vm.activeTab === _vm.data.value && 'active'],on:{"click":_vm.onChangeTab}},[_vm._v(" "+_vm._s(_vm.data.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }